import { ThemeProvider } from '@material-ui/core/styles';
import { muiTheme } from '@setvi/shared/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import QuoteSharePage from './pages/quote-share';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false
    }
  }
});

const App = () => (
  <ThemeProvider theme={muiTheme}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/quote/:companyId/:token" element={<QuoteSharePage />} />
          <Route path="*" element={<QuoteSharePage />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </ThemeProvider>
);

export default App;
